/* GB Custom Bundle Box controller v2 (viewport selector fix 2026-07-13).
   Adds: Buy-1 color slot, CHANGE BLASTER button, full-screen filterable modal
   (category chips from product types + bestsellers + price sort), image-fallback
   swatch dots, sticky-ATC scroll gating, modal scroll-lock above the sticky bar.
   One-write ATC (2026-10-20): the extras and the gift-wrap line ride in the native
   form submit as hidden items[] / attributes[] fields (native drawer render + open).
   Checkout pricing is enforced by the native automatic discounts (SAVE 55% / SAVE 60%). */
(function () {
  'use strict';
  if (window.__gbbInit) return; window.__gbbInit = true;

  /* Buy 2 "Free Shipping" label (2026-09-24). Pure check: same threshold conversion as the gbfs cart bar
     (assets/gb-free-shipping.js: Math.round(base * Shopify.currency.rate)). The base comes from the snippet
     constant gbb_freeship_base_cents (cfg.freeShipBaseCents). Missing base or rate = never show. */
  function gbbFreeShipQualifies(totalCents, baseCents, rate) {
    var base = Number(baseCents), r = Number(rate);
    if (!(base > 0) || !(r > 0)) return false;
    return Math.floor(Number(totalCents) || 0) >= Math.round(base * r);
  }

  /* BOS:EXPERIMENT — generic BundleOS experiment hook (bestseller-plus5-2026-10 price test; since 2026-10-21 also
     the store-wide offer test shellblaster-offer-b3g1-2026-10). Active only when BundleOSExp.forProduct(host) returns
     this visitor's arm for the host product (assigned, USD, not a bot or feed click, product in the experiment). Every
     other visitor keeps today's widget unchanged.
       - price arms (R3a / R8): project the SAME variant price the Cart Transform charges; compare-at keeps the live
         price/compare ratio, rounded up to the whole unit; the root becomes a projected surface for the embed;
       - every arm, control included: each add carries _bos_exp = "<experimentId>:<variantKey>";
       - the arm's widgets['gb-bundle-box'] patch is applied before the first render:
           defaultTier             preselected tier index (absent = Buy 2, today);
           tierPatch {"i": {...}}  merged into tier i only (qty, disc, save, plus, title, club, pack, slots);
           clubProductIds [ids]    products the Blaster Club 5% really applies to.
         With a patch the box shows the exact charge: per unit, the best of the tier discount (native ladder or the arm's
         own tier discount) and the Club price (only for Club products, stacked by the Club units in the selection);
         Shopify keeps one product discount per line and truncates each unit's discount to the cent.
       - a patched tier with pack:true (the offer test's "Buy 3, Get 1 FREE", redesign 2026-10-21 = the approved mock,
         calmer phone-first redesign 2026-10-22) gets the 4-pack display: the title on one line in the tier title style,
         no sub-line, the shared theme pill reading "4th FREE" under the title, no badge, round swap buttons, and the
         cheapest unit (the last row by default) in a plain row with a small "FREE" label.
         Display only: the charge and the cart lines are unchanged. */
  function bosApi() { var a = window.BundleOSExp; return a && typeof a.forProduct === 'function' ? a : null; }
  function bosRecord(hostId) {
    try {
      var api = bosApi();
      var rec = api ? api.forProduct(hostId) : null;
      return rec && rec.experimentId && rec.variantKey ? rec : null;
    } catch (e) { return null; }
  }
  function bosProject(cfg) {
    var api = bosApi();
    var vids = [], projected = 0;
    var products = (cfg.products || []).map(function (product) {
      var inTest = false;
      try { inTest = !!api.forProduct(product.id); } catch (e) { inTest = false; }
      if (!inTest) return product;
      var vs = (product.vs || []).map(function (v) {
        vids.push(v.id);
        var price = null;
        try { price = api.priceFor(v.id); } catch (e) { price = null; }
        if (typeof price !== 'number' || !isFinite(price) || price <= 0) return v;
        var cents = Math.round(price * 100);
        var cp = v.cp;
        if (v.p > 0 && v.cp > v.p) cp = Math.ceil(cents * v.cp / v.p / 100) * 100;
        projected += 1;
        return Object.assign({}, v, { p: cents, cp: cp, __bosPrice: true });
      });
      return Object.assign({}, product, { vs: vs });
    });
    return { cfg: Object.assign({}, cfg, { products: products }), vids: vids, projected: projected };
  }
  var BOS_TIER_KEYS = ['qty', 'disc', 'save', 'plus', 'title', 'club', 'pack', 'slots'];
  function bosPatch(cfg, rec) {
    var w = rec && rec.widgets && rec.widgets['gb-bundle-box'];
    if (!w || typeof w !== 'object' || cfg.variantBundle) return { cfg: cfg, patched: false };
    var tiers = Array.isArray(w.tiers) ? w.tiers : (cfg.tiers || []);
    tiers = tiers.map(function (t) { return Object.assign({}, t); });
    var tp = w.tierPatch && typeof w.tierPatch === 'object' ? w.tierPatch : {};
    Object.keys(tp).forEach(function (k) {
      var i = Number(k), p = tp[k];
      if (!(i >= 0 && i < tiers.length) || !p || typeof p !== 'object') return;
      BOS_TIER_KEYS.forEach(function (key) { if (Object.prototype.hasOwnProperty.call(p, key)) tiers[i][key] = p[key]; });
      tiers[i].bosPatched = true;
    });
    if (Array.isArray(w.tiers)) tiers.forEach(function (t) { t.bosPatched = true; });
    var out = Object.assign({}, cfg, { tiers: tiers });
    if (typeof w.defaultTier === 'number' && w.defaultTier >= 0 && w.defaultTier < tiers.length) out.defaultTier = w.defaultTier;
    if (typeof w.maxQty === 'number') out.maxQty = w.maxQty;
    if (Array.isArray(w.clubProductIds)) {
      out.bosClub = {};
      w.clubProductIds.forEach(function (id) { out.bosClub[String(id)] = 1; });
    }
    return { cfg: out, patched: true };
  }
  function bosExperimentProductIds(rec) {
    try {
      var list = (bosApi().config || {}).experiments || [];
      for (var i = 0; i < list.length; i++) {
        if (list[i] && list[i].id === rec.experimentId) {
          var map = {};
          (list[i].productIds || []).forEach(function (id) { map[String(id).replace(/\D/g, '')] = 1; });
          return map;
        }
      }
    } catch (e) {}
    return null;
  }
  /* BOS:END-EXPERIMENT */

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  // Multi-instance registry: the widget can be injected repeatedly (PDP + every
  // collection quick-view). Each [data-gbb] root gets its own bound instance; the
  // single document-level submit interceptor routes a form to the instance whose
  // container holds it.
  var instances = [];

  // The Outlaw loadout reuses the main product form for its hidden kit variants.
  // Its normal bundle-box widget remains in the DOM for the classic PDP route,
  // but must not own that form while the link-gated loadout is active.
  function isSuppressedOutlawLoadoutRoot(root) {
    return !!(root && document.documentElement.classList.contains('gol-offer-on') &&
      root.closest('[data-gbb-outlaw-normal]'));
  }

  function initWidget(root) {
    if (isSuppressedOutlawLoadoutRoot(root)) return;
    if (root.__gbbBound) return;
    root.__gbbBound = true;
    var dataEl = root.parentNode ? root.parentNode.querySelector('script[data-gbb-data]') : null;
    if (!dataEl) return;
    var container = root.closest('quick-add-modal, .quick-add-modal, dialog, .shopify-section') || document.body;

    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var bosRec = bosRecord(cfg.hostId);
    var bosValue = null, bosPatched = false, bosScope = null;
    if (bosRec) {
      var bosP = bosProject(cfg);
      cfg = bosP.cfg;
      if (bosP.projected) {
        root.setAttribute('data-bos-projected', String(cfg.hostId));
        root.setAttribute('data-bos-projected-variants', bosP.vids.join(','));
      }
      var bosW = bosPatch(cfg, bosRec);
      cfg = bosW.cfg;
      bosPatched = bosW.patched;
      bosScope = bosExperimentProductIds(bosRec);
      bosValue = bosRec.experimentId + ':' + bosRec.variantKey;
      root.setAttribute('data-bos-arm', bosValue);
    }

    var byId = {};
    (cfg.products || []).forEach(function (p) { byId[p.id] = p; });
    var host = byId[cfg.hostId];
    if (!host) return;

    /* ---------- money formatting (derived from a Liquid-localized sample) ---------- */
    var fmt = (function (sample) {
      var m = sample.match(/[\d.,\s  ']*\d/);
      var num = m ? m[0] : '1,234.56';
      var idx = sample.indexOf(num);
      var pre = sample.slice(0, idx), suf = sample.slice(idx + num.length);
      var decSep = '.', thoSep = ',', decimals = 2;
      var c = num.length >= 3 ? num.charAt(num.length - 3) : '';
      if (c && /[^\d]/.test(c)) {
        decSep = c;
        var rest = num.slice(0, num.length - 3).replace(/\d/g, '');
        thoSep = rest ? rest.charAt(rest.length - 1) : (decSep === '.' ? ',' : '.');
      } else { decimals = 0; thoSep = (num.replace(/\d/g, '') || ',').charAt(0); }
      return function (cents) {
        var n = (cents / 100).toFixed(decimals);
        var parts = n.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thoSep);
        return pre + (decimals ? parts[0] + decSep + parts[1] : parts[0]) + suf;
      };
    })(cfg.moneySample || '$1,234.56');

    /* ---------- state ---------- */
    var state = {
      tier: typeof cfg.defaultTier === 'number' ? cfg.defaultTier : 1,   // preselected: Buy 2 (an arm may preselect another tier)
      qty: 3,                                     // Buy 3+ stepper value
      slots: { 1: [null], 2: [null, null] },      // per-tier extra slots; null = follow host
      hostVid: cfg.hostVariantId,
      filter: 'all',                              // 'all' | 'bs' | <product type>
      sort: ''                                    // '' | 'asc' | 'desc'
    };

    function mainForm() {
      return container.querySelector('form[id="product-form-' + cfg.sectionId + '"]') ||
        container.querySelector('product-form form[data-type="add-to-cart-form"]');
    }
    function readHostVid() {
      var f = mainForm();
      if (f) {
        var inp = f.querySelector('input[name="id"], select[name="id"]');
        if (inp && inp.value) state.hostVid = Number(inp.value);
      }
      return state.hostVid;
    }

    function findVariant(p, vid) {
      for (var i = 0; i < p.vs.length; i++) if (p.vs[i].id === vid) return p.vs[i];
      return p.vs[0];
    }
    function slotResolved(slot) {
      if (!slot) { var v = findVariant(host, readHostVid()); return { p: host, v: v }; }
      var p = byId[slot.pid] || host;
      return { p: p, v: findVariant(p, slot.vid) };
    }
    function tierUnits() {
      var t = cfg.tiers[state.tier];
      if (!t) return 1;
      return t.plus ? state.qty : t.qty;
    }
    function discPct() { return (cfg.tiers[state.tier] || {}).disc || 0; }
    function unitPrice(cents, disc) { return Math.round(cents * (100 - disc) / 100); }
    function ordinal(n) { return n === 2 ? '2nd' : n === 3 ? '3rd' : n + 'th'; }
    function esc(v) {
      return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* swatch dot: mapped color name, else the variant image itself (always accurate) */
    function dotStyle(v) {
      var hex = cfg.swatches[v.c];
      if (hex) return 'background:' + hex;
      return 'background-image:url(' + v.img + ')';
    }
    function colorChip(v, caret) {
      return '<span class="gbb-dot" style="' + dotStyle(v) + '"></span>' +
        '<span class="gbb-chip-label">' + esc(v.c) + '</span>' + (caret ? '<span class="gbb-car">&#9660;</span>' : '');
    }

    /* ---------- bars / slots rendering ---------- */
    var bars = [].slice.call(root.querySelectorAll('[data-gbb-bar]'));

    function syncSlotCount() {
      if (state.tier === 0) return;
      var extras = tierUnits() - 1;
      var arr = state.slots[state.tier] || [];
      while (arr.length < extras) arr.push(null);
      arr.length = extras;
      state.slots[state.tier] = arr;
    }

    function tierTotals(tierIndex) {
      var hv = findVariant(host, readHostVid());
      var t = cfg.tiers[tierIndex] || { qty: 1, disc: 0 };
      var qty = t.plus && tierIndex === state.tier ? state.qty : (t.qty || 1);
      var slots = state.slots[tierIndex] || [];
      var sum = hv.p, cmp = hv.cp || hv.p;
      for (var i = 0; i < qty - 1; i++) {
        var r = slotResolved(slots[i] || null);
        sum += r.v.p;
        cmp += (r.v.cp || r.v.p);
      }
      return { price: unitPrice(sum, t.disc || 0), compare: cmp };
    }

    function clubFactor() {
      if (cfg.clubOff) return 1;   // the Club price never reaches this blaster in the cart (gb-bundle-box.liquid)
      try {
        var scope = (root.closest && (root.closest('.product__info-container,.main-product__info-container') || root.closest('quick-add-modal'))) || null;
        var cb = (scope && scope.querySelector('[data-gb-membership] .gb-check')) || document.querySelector('[data-gb-membership] .gb-check');
        return cb && cb.checked ? 0.95 : 1;
      } catch (e) { return 1; }
    }
    /* BOS:EXPERIMENT exact pricing (only with an arm patch that carries clubProductIds, i.e. assigned visitors).
       Shopify keeps ONE product discount per line (the best) and truncates each unit's discount to the cent:
       unit charge = p - floor(p * pct / 100). Candidates per unit: the tier discount (native ladder 5/10, or the
       arm's own tier discount such as 25) and, for Club products while the Club box is ticked and the tier allows it,
       the Club Special Price: 5%, stacked 9.75% / 14.5% by the Club units in the selection. */
    var bosExact = !!(bosPatched && cfg.bosClub && !cfg.variantBundle);
    function bosIsClub(p) { return !!(cfg.bosClub && p && cfg.bosClub[String(p.id)]); }
    function bosClubPct(units) { return units >= 3 ? 14.5 : units >= 2 ? 9.75 : 5; }
    function bosUnitCharge(cents, pct) { return cents - Math.floor(cents * pct / 100 + 1e-7); }
    function bosSelection(i) {
      var t = cfg.tiers[i] || {};
      var n = t.plus && i === state.tier ? state.qty : (t.qty || 1);
      var slots = state.slots[i] || [];
      var list = [{ p: host, v: findVariant(host, readHostVid()) }];
      for (var k = 0; k < n - 1; k++) list.push(slotResolved(slots[k] || null));
      return list;
    }
    function bosPcts(i, list) {
      var t = cfg.tiers[i] || {};
      var tierPct = Number(t.disc) || 0;
      var clubOn = t.club !== false && clubFactor() < 1;
      var clubUnits = 0;
      if (clubOn) list.forEach(function (u) { if (bosIsClub(u.p)) clubUnits++; });
      return list.map(function (u) {
        var pct = tierPct;
        if (clubOn && bosIsClub(u.p)) pct = Math.max(pct, bosClubPct(clubUnits));
        return pct;
      });
    }
    function bosTierCharge(i) {
      var list = bosSelection(i), pcts = bosPcts(i, list), total = 0;
      list.forEach(function (u, k) { total += bosUnitCharge(u.v.p, pcts[k]); });
      return { host: bosUnitCharge(list[0].v.p, pcts[0]), total: total, units: list.length };
    }
    function bosFreeShip(totalCents) {
      var cur = (window.Shopify && window.Shopify.currency) || {};
      var rate = Number(cur.rate) || (cfg.shopCurrency ? 1 : 0);
      return gbbFreeShipQualifies(totalCents, cfg.freeShipBaseCents, rate);
    }
    /* BOS:EXPERIMENT 4-pack display (Emi 2026-10-21: "cleaner and simpler less text and highlight it a little that the
       4th blaster is free"; first built as the approved mock design-mock/mock.html). Calmer, phone-first redesign
       2026-10-22 (Emi: "too much color, too much text, too much stuff going on ... it has to be optimized for mobile
       always"): it now looks like the other tiers. Only a patched fixed-qty tier with pack:true whose discount equals one
       free unit (disc * qty = 100, e.g. 25% x 4), for an assigned visitor with exact pricing. Title "Buy 3, Get 1 FREE"
       in the tier title style on one line (a box too narrow for it breaks only after the comma: "Buy 3," / "Get 1 FREE"),
       no sub-line (no "4 for $X", no shipping text: Buy 2 keeps its own label, so the box shows at most one), the theme's
       shared .gbb-pill reading "4th FREE" under the title (no emoji, no extra color), the price column as every tier, no
       "Best Deal" badge, round swap buttons, and plain slot rows: the cheapest unit (ties: the last row; with 4 equal
       units the 4th row) only gets a small "FREE" label in the "Free Shipping" green, only while its own price does not
       exceed the real saving. Emi 2026-10-22 ("a little bit highlight for the free one"): that label is a small green
       pill and its row a light green tint (box-shadow, no layout shift). Display only: every unit is still charged its
       own price minus disc (bosTierCharge), so the cart and the line properties do not change. Every other tier and
       visitor renders exactly as before (bosPack = -1). */
    var bosPack = -1;
    if (bosExact) {
      for (var bpi = 0; bpi < cfg.tiers.length; bpi++) {
        var bpt = cfg.tiers[bpi];
        if (bpt && bpt.bosPatched && bpt.pack === true && !bpt.plus && bpt.qty > 1 && Number(bpt.disc) * bpt.qty === 100) { bosPack = bpi; break; }
      }
    }
    /* Layout only: radio | title over the pill | prices (the pill sits where Buy 2 shows "Free Shipping", so the title
       keeps the whole middle column and stays on one line on a 390 px phone). Colors and type stay the theme's. */
    var BOS_PACK_CSS =
      '.gbb-bar[data-bos-pack] .gbb-badge{display:none}' +
      '.gbb-bar[data-bos-pack] .gbb-row{display:grid;grid-template-columns:auto minmax(0,1fr) auto;column-gap:10px;row-gap:6px;align-items:center}' +
      '.gbb-bar[data-bos-pack] .gbb-radio{grid-column:1;grid-row:1/span 2}' +
      '.gbb-bar[data-bos-pack] .gbb-title{grid-column:2;grid-row:1;display:block;align-self:end}' +
      '.gbb-bar[data-bos-pack] .gbb-bos-nw{white-space:nowrap}' +
      '.gbb-bar[data-bos-pack] .gbb-pill{grid-column:2;grid-row:2;justify-self:start;align-self:start}' +
      '.gbb-bar[data-bos-pack] .gbb-prices{grid-column:3;grid-row:1/span 2}' +
      '.gbb-bos-freetag{align-self:flex-start;font-size:12px;font-weight:800;color:#fff;background:#49A670;border-radius:999px;padding:3px 9px;letter-spacing:.5px;line-height:1.2}' +
      '.gbb-slot[data-bos-free]{border-radius:14px;background:#EBF7EF;box-shadow:0 0 0 6px #EBF7EF,0 0 0 7px #C4E5D0}' +
      '.gbb-choose.gbb-bos-swap{width:38px;height:38px;min-width:0;border-radius:999px;padding:0;font-size:18px;line-height:38px}';
    function bosPackCss() {
      if (document.getElementById('gbb-bos-pack-css')) return;
      var st = document.createElement('style');
      st.setAttribute('id', 'gbb-bos-pack-css');
      st.textContent = BOS_PACK_CSS;
      (document.head || document.documentElement).appendChild(st);
    }
    /* index of the unit shown as FREE: the cheapest (ties: the last), only if it costs at most the real saving plus one
       minor unit per unit (the per-unit rounding of the discount: EUR 39.94 x 4 saves 39.92, so the row still shows) */
    function bosPackFree() {
      var list = bosSelection(bosPack), ch = bosTierCharge(bosPack), regular = 0, min = Infinity, free = -1;
      list.forEach(function (u, k) { var p = u.v.p; regular += p; if (p <= min) { min = p; free = k; } });
      return free >= 0 && min <= regular - ch.total + list.length ? free : -1;
    }
    function bosPackMarkup(bar, t, title, pill) {
      bosPackCss();
      bar.setAttribute('data-bos-pack', '1');
      /* same text, one color: the only break opportunity is after the comma ("Buy 3," / "Get 1 FREE") */
      var tn = title && title.firstChild;
      var m = tn && tn.nodeType === 3 ? /^(.+?,)\s+(\S.*?)\s*$/.exec(tn.nodeValue) : null;
      if (m) {
        tn.nodeValue = ' ';
        [m[1], m[2]].forEach(function (part, k) {
          var nw = document.createElement('span');
          nw.setAttribute('class', 'gbb-bos-nw');
          nw.textContent = part;
          title.insertBefore(nw, k ? tn.nextSibling : tn);
        });
      }
      if (pill) pill.textContent = ordinal(t.qty) + ' FREE';
    }
    function bosPackRowsHtml(hv, free) {
      var rows = [{ p: host, v: hv }];
      (state.slots[state.tier] || []).forEach(function (slot) { rows.push(slotResolved(slot)); });
      return rows.map(function (res, k) {
        var isFree = k === free;
        return '<div class="gbb-slot" data-slot="' + k + '" data-vid="' + res.v.id + '"' + (isFree ? ' data-bos-free="1"' : '') + '>' +
          '<img class="gbb-slot-img" src="' + res.v.img + '" alt="" decoding="async">' +
          '<div class="gbb-slot-info"><span class="gbb-slot-name">' + esc(res.p.t) + '</span>' +
          (isFree ? '<span class="gbb-bos-freetag">FREE</span>' : '') +
          (res.p.vs.length > 1
            ? '<span class="gbb-pop"><button type="button" class="gbb-chip" data-gbb-color="' + k + '">' + colorChip(res.v, true) + '</button></span>'
            : '') +
          '</div>' +
          (k > 0 ? '<div class="gbb-slot-actions"><button type="button" class="gbb-choose gbb-bos-swap" data-gbb-open="' + k + '" aria-label="Change blaster" title="Change blaster">&#8644;</button></div>' : '') +
          '</div>';
      }).join('');
    }
    function bosApplyTierMarkup() {
      bars.forEach(function (bar, i) {
        var t = cfg.tiers[i];
        if (!t || !t.bosPatched) return;
        if (typeof t.disc === 'number') bar.setAttribute('data-disc', String(t.disc));
        var title = bar.querySelector('.gbb-title');
        if (t.title && title && title.firstChild && title.firstChild.nodeType === 3) title.firstChild.nodeValue = t.title;
        var pill = bar.querySelector('.gbb-pill');
        if (pill && typeof t.save === 'number') pill.textContent = 'SAVE ' + t.save + '%';
        var stepper = bar.querySelector('.gbb-stepper');
        if (stepper) stepper.hidden = !t.plus;
        if (i === bosPack) bosPackMarkup(bar, t, title, pill);
        bar.setAttribute('data-bos-patched', '1');
      });
    }
    function renderPrices() {
      var hv = findVariant(host, readHostVid());
      var mf = clubFactor();
      bars.forEach(function (bar, i) {
        var disc = Number(bar.getAttribute('data-disc')) || 0;
        var pEl = bar.querySelector('[data-gbb-price]');
        var cEl = bar.querySelector('[data-gbb-cmp]');
        var totals = cfg.variantBundle ? tierTotals(i) : null;
        var t = cfg.tiers[i] || {};
        var charge = bosExact ? bosTierCharge(i) : null;
        // Buy 2 / Buy 3+ show the row's TOTAL for the chosen blasters (Emi 2026-10-30, Kit Audience "do all"), with the
        // same math as the Free Shipping label (buy2TotalCents); Buy 1 stays one blaster.
        var row = !totals && !charge ? exactRow(i) : null;   // Buy 1 = one blaster; Buy 2 / Buy 3+ = the row total
        if (pEl) pEl.textContent = fmt(charge ? (i > 0 ? charge.total : charge.host)
          : row ? row.total : Math.round(totals.price * mf));
        if (cEl) cEl.textContent = fmt(totals ? totals.compare : row ? row.compare : (hv.cp || hv.p));
        if (charge && t.pack) {
          var sub = bar.querySelector('.gbb-sub');
          if (sub && i === bosPack) sub.hidden = true;   // 4-pack display: no sub-line (no "4 for $X", no shipping text)
          else if (sub) {
            var text = charge.units + ' for ' + fmt(charge.total) + (bosFreeShip(charge.total) ? ' · Free Shipping' : '');
            if (sub.textContent !== text) sub.textContent = text;
            sub.hidden = false;
          }
        }
      });
      try { renderFreeShip(); } catch (e) {}
      if (root.hasAttribute('data-bos-prepaint')) root.removeAttribute('data-bos-prepaint');
    }
    /* Buy 2 total as the widget computes it: host + chosen Buy 2 slot, tier discount, then Club factor
       (exact per-unit charges when an arm patch is active). */
    function buy2TotalCents() {
      if (bosExact) return bosTierCharge(1).total;
      return exactRow(1).total;
    }
    /* What the cart charges for a tier's blasters, to the cent (2026-10-30, rows show TOTALS): checkout keeps ONE
       product discount per line (the best of the tier discount and, with the Club box ticked, the Club Special Price
       5% / 9.75% / 14.5% by the units) and truncates each unit's discount to the cent: unit = p - floor(p * pct / 100).
       Same math as bosTierCharge, with every unit counted as a Club unit (all box blasters are Club products). */
    function exactRow(i) {
      var t = cfg.tiers[i] || {};
      var n = t.plus && i === state.tier ? state.qty : (t.qty || 1);
      var slots = state.slots[i] || [];
      var list = [findVariant(host, readHostVid())];
      for (var k = 0; k < n - 1; k++) list.push(slotResolved(slots[k] || null).v);
      var pct = Number(t.disc) || 0;
      if (t.club !== false && clubFactor() < 1) pct = Math.max(pct, bosClubPct(list.length));
      var total = 0, compare = 0;
      list.forEach(function (v) { total += bosUnitCharge(v.p, pct); compare += (v.cp || v.p); });
      return { total: total, compare: compare };
    }
    function renderFreeShip() {
      var el = bars[1] && bars[1].querySelector('[data-gbb-fs]');
      if (!el) return;
      var cur = (window.Shopify && window.Shopify.currency) || {};
      var rate = Number(cur.rate) || (cfg.shopCurrency ? 1 : 0);
      var q = gbbFreeShipQualifies(buy2TotalCents(), cfg.freeShipBaseCents, rate);
      if (el.hidden === q) el.hidden = !q;
    }
    document.addEventListener('gb-club:toggle', function () { try { renderPrices(); } catch (e) {} });

    function slotRowHtml(res, slotIdx, withChange, label) {
      var slotName = cfg.variantBundle ? 'Bundle ' + (slotIdx + 1) : res.p.t;
      return '<div class="gbb-slot" data-slot="' + slotIdx + '" data-vid="' + res.v.id + '">' +
        '<img class="gbb-slot-img" src="' + res.v.img + '" alt="" decoding="async">' +
        '<div class="gbb-slot-info"><span class="gbb-slot-name">' + esc(slotName) + '</span>' +
        (res.p.vs.length > 1
          ? '<span class="gbb-pop"><button type="button" class="gbb-chip" data-gbb-color="' + slotIdx + '">' + colorChip(res.v, true) + '</button></span>'
          : '') +
        '</div>' +
        (withChange
          ? '<div class="gbb-slot-actions"><button type="button" class="gbb-choose" data-gbb-open="' + slotIdx + '">' + label + '</button></div>'
          : '') +
        '</div>';
    }

    function renderSlots() {
      var bar = bars[state.tier];
      if (!bar) return;
      var wrap = bar.querySelector('[data-gbb-slots]');
      if (!wrap) return;
      syncSlotCount();
      var hv = findVariant(host, readHostVid());
      var html;
      if (state.tier === bosPack) html = bosPackRowsHtml(hv, bosPackFree());
      else {
        html = slotRowHtml({ p: host, v: hv }, 0, false, '');
        (state.slots[state.tier] || []).forEach(function (slot, i) {
          var r = slotResolved(slot);
          html += slotRowHtml(r, i + 1, !cfg.variantBundle, '&#8644; CHANGE<small>BLASTER</small>');
        });
      }
      if (wrap.__gbbLast !== html) {
        wrap.innerHTML = html;
        wrap.__gbbLast = html;
      }
      renderTotal();
    }

    function renderTotal() {
      var bar = bars[state.tier];
      if (!bar) return;
      var el = bar.querySelector('[data-gbb-total]');
      if (!el) return;
      el.hidden = true;
      el.style.display = 'none';
      el.innerHTML = '';
    }

    function renderTier() {
      bars.forEach(function (bar, i) {
        var on = i === state.tier;
        bar.classList.toggle('on', on);
        bar.setAttribute('aria-checked', on ? 'true' : 'false');
        var ex = bar.querySelector('[data-gbb-expand]');
        if (ex) ex.hidden = !on;
      });
      var qEl = root.querySelector('[data-gbb-qty]');
      if (qEl) qEl.textContent = state.qty;
      renderPrices();
      renderSlots();
    }

    /* ---------- native variant picker sync ---------- */
    function nativePicker() {
      return container.querySelector('variant-selects[data-section="' + cfg.sectionId + '"], variant-radios[data-section="' + cfg.sectionId + '"]');
    }
    function setNativeVariant(v) {
      var np = nativePicker();
      if (!np) return;
      var parts = v.c.split(' / ');
      var selects = np.querySelectorAll('select');
      if (selects.length) {
        selects.forEach(function (sel, i) { if (parts[i] != null) sel.value = parts[i]; });
        selects[0].dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      var radios = np.querySelectorAll('input[type="radio"]');
      radios.forEach(function (r) { if (parts.indexOf(r.value) > -1 && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); } });
    }

    /* ---------- color popover ---------- */
    function closePops() {
      [].slice.call(document.querySelectorAll('.gbb-pop-list')).forEach(function (n) {
        if (n.__gbbCleanup) n.__gbbCleanup();
        n.remove();
      });
    }
    function popViewport() {
      var vv = window.visualViewport;
      return {
        top: vv ? vv.offsetTop : 0,
        left: vv ? vv.offsetLeft : 0,
        width: vv ? vv.width : (document.documentElement.clientWidth || window.innerWidth),
        height: vv ? vv.height : window.innerHeight
      };
    }
    function popLayout(rect, viewport, naturalHeight) {
      var edge = 8, gap = 6;
      var viewTop = viewport.top + edge;
      var viewLeft = viewport.left + edge;
      var viewRight = viewport.left + viewport.width - edge;
      var viewBottom = viewport.top + viewport.height - edge;
      var anchorTop = rect.top + viewport.top;
      var anchorBottom = rect.bottom + viewport.top;
      var width = Math.min(Math.max(180, rect.width), Math.max(0, viewport.width - (edge * 2)));
      var left = Math.max(viewLeft, Math.min(rect.left + viewport.left, viewRight - width));
      var above = Math.max(0, anchorTop - gap - viewTop);
      var below = Math.max(0, viewBottom - anchorBottom - gap);
      var opensUp = above >= naturalHeight || (below < naturalHeight && above > below);
      var space = opensUp ? above : below;
      var maxHeight = Math.max(0, Math.floor(space));
      var height = Math.min(naturalHeight, maxHeight);
      var top = opensUp ? anchorTop - gap - height : anchorBottom + gap;

      if (maxHeight < 48) {
        maxHeight = Math.max(0, Math.floor(viewBottom - viewTop));
        height = Math.min(naturalHeight, maxHeight);
        top = viewTop;
      }
      top = Math.max(viewTop, Math.min(top, viewBottom - height));
      return { top: top, left: left, width: width, maxHeight: maxHeight, opensUp: opensUp };
    }
    function positionPop(list, anchor) {
      var viewport = popViewport();
      var rect = anchor.getBoundingClientRect();
      var firstPass = popLayout(rect, viewport, 9999);
      list.style.width = Math.round(firstPass.width) + 'px';
      var layout = popLayout(rect, viewport, list.scrollHeight);
      list.style.top = Math.round(layout.top) + 'px';
      list.style.left = Math.round(layout.left) + 'px';
      list.style.maxHeight = Math.round(layout.maxHeight) + 'px';
      list.classList.toggle('up', layout.opensUp);
      list.style.visibility = 'visible';
    }
    function popFor(anchor, p, curVid, onPick) {
      closePops();
      p.vs.forEach(function (v) { if (v.img) { var im = new Image(); im.src = v.img; } });
      var list = document.createElement('div');
      list.className = 'gbb-pop-list';
      list.style.visibility = 'hidden';
      list.innerHTML = p.vs.map(function (v) {
        return '<button type="button" class="gbb-pop-item' + (v.id === curVid ? ' on' : '') + '" data-vid="' + v.id + '">' +
          '<span class="gbb-dot" style="' + dotStyle(v) + '"></span>' + esc(v.c) + '</button>';
      }).join('');
      list.addEventListener('click', function (e) {
        var b = e.target.closest('[data-vid]');
        if (!b) return;
        onPick(Number(b.getAttribute('data-vid')));
        closePops();
      });
      document.body.appendChild(list);
      positionPop(list, anchor);

      var closeOnMove = function (e) {
        if (e && e.target && e.target.nodeType && list.contains(e.target)) return; // window/visualViewport targets are not Nodes
        closePops();
      };
      window.addEventListener('scroll', closeOnMove, true);
      window.addEventListener('resize', closeOnMove);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('scroll', closeOnMove);
        window.visualViewport.addEventListener('resize', closeOnMove);
      }
      list.__gbbCleanup = function () {
        window.removeEventListener('scroll', closeOnMove, true);
        window.removeEventListener('resize', closeOnMove);
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('scroll', closeOnMove);
          window.visualViewport.removeEventListener('resize', closeOnMove);
        }
        list.__gbbCleanup = null;
      };
    }
    function openColorPop(slotIdx, anchor) {
      var slot = slotIdx === 0 ? null : state.slots[state.tier][slotIdx - 1];
      var r = slotResolved(slot);
      var cur = slotIdx === 0 ? findVariant(host, readHostVid()) : r.v;
      popFor(anchor, r.p, cur.id, function (vid) {
        if (slotIdx === 0) {
          setNativeVariant(findVariant(host, vid));
          state.hostVid = vid;
        } else {
          state.slots[state.tier][slotIdx - 1] = { pid: r.p.id, vid: vid };
        }
        renderPrices(); renderSlots();
      });
    }

    /* ---------- modal ---------- */
    var modal = root.querySelector('[data-gbb-modal]');
    var modalSlot = null;
    // portal to <body>: ancestor sections carry transform/isolate (theme scroll animations),
    // which re-anchors position:fixed and traps the sheet inside the page container on phones
    if (modal && modal.parentNode !== document.body) document.body.appendChild(modal);

    /* BOS:EXPERIMENT — a tier with slots:"experiment" (the offer-test 4-pack) only offers products of the same
       experiment, so every unit it adds is one the arm's offer prices. */
    function catalogProducts() {
      var t = cfg.tiers[state.tier] || {};
      if (t.slots !== 'experiment' || !bosScope) return cfg.products;
      return cfg.products.filter(function (p) { return !!bosScope[String(p.id)]; });
    }
    function productTypes() {
      var seen = {}, out = [];
      catalogProducts().forEach(function (p) {
        if (p.ty && !seen[p.ty]) { seen[p.ty] = 1; out.push(p.ty); }
      });
      return out;
    }
    function filteredProducts() {
      var list = catalogProducts().slice();
      if (state.filter === 'bs') list = list.filter(function (p) { return p.bs; });
      else if (state.filter !== 'all') list = list.filter(function (p) { return p.ty === state.filter; });
      if (state.sort === 'asc') list.sort(function (a, b) { return a.vs[0].p - b.vs[0].p; });
      if (state.sort === 'desc') list.sort(function (a, b) { return b.vs[0].p - a.vs[0].p; });
      return list;
    }

    function renderFilters() {
      var bar = modal.querySelector('[data-gbb-filters]');
      if (!bar) return;
      var sortLabel = state.sort === 'asc' ? '&#8593; Price: Low' : state.sort === 'desc' ? '&#8595; Price: High' : '&#8645; Price';
      var chips = '<button type="button" class="gbb-fchip gbb-fsortchip' + (state.sort ? ' on' : '') + '" data-gbb-sortcycle>' + sortLabel + (state.sort ? ' &#10005;' : '') + '</button>' +
        '<button type="button" class="gbb-fchip' + (state.filter === 'all' ? ' on' : '') + '" data-gbb-filter="all">All</button>' +
        productTypes().map(function (t) {
          return '<button type="button" class="gbb-fchip' + (state.filter === t ? ' on' : '') + '" data-gbb-filter="' + esc(t) + '">' + esc(t) + '</button>';
        }).join('');
      bar.innerHTML = chips;
    }

    function renderList() {
      var t = cfg.tiers[state.tier] || {};
      var disc = discPct();
      var list = modal.querySelector('[data-gbb-list]');
      var items = filteredProducts();
      if (!items.length) { list.innerHTML = '<div class="gbb-empty">No blasters match this filter.</div>'; return; }
      list.innerHTML = items.map(function (p) {
        var v = p.vs[0];
        var save = v.cp > v.p && state.tier !== bosPack ? (t.save || 70) : 0;   // 4-pack picker: no SAVE label
        var first = esc((p.t.split(' ')[0] || 'THIS').toUpperCase());
        return '<div class="gbb-item" data-pid="' + p.id + '">' +
          '<img class="gbb-item-img" src="' + v.img + '" alt="" loading="lazy" decoding="async">' +
          '<div class="gbb-item-info"><span class="gbb-item-name">' + esc(p.t) +
          (p.h === 'raven' ? '<span class="gbb-item-bs">&#9733; BESTSELLER</span>' : '') +
          (demoMedia(p) ? '<span class="gbb-item-car2" aria-hidden="true">&#8964;</span>' : '') + '</span>' +
          '<span class="gbb-item-prices"><span class="gbb-item-price">' + fmt(unitPrice(v.p, disc)) + '</span>' +
          (v.cp > v.p ? '<s class="gbb-item-cmp">' + fmt(v.cp) + '</s>' : '') +
          (save > 0 ? '<span class="gbb-item-save">SAVE ' + save + '%</span>' : '') + '</span>' +
          '</div>' +
          '<div class="gbb-item-foot">' +
          (p.vs.length > 1 ? '<span class="gbb-pop"><button type="button" class="gbb-chip" data-gbb-mcolor="' + p.id + '" data-vid="' + v.id + '">' + colorChip(v, true) + '</button></span>' : '<span></span>') +
          '<button type="button" class="gbb-choose" data-gbb-pick="' + p.id + '" data-vid="' + v.id + '">CHOOSE ' + first + '</button></div></div>';
      }).join('');
      list.scrollTop = 0;
    }

    function openModal(slotIdx) {
      modalSlot = slotIdx;
      var t = cfg.tiers[state.tier] || {};
      var title = modal.querySelector('[data-gbb-modal-title]');
      if (title) title.innerHTML = 'Choose your ' + ordinal(slotIdx + 1) + ' blaster' + (state.tier === bosPack ? '' : ' &mdash; <em>SAVE ' + (t.save || 70) + '%</em>');
      state.filter = 'all'; state.sort = '';
      renderFilters();
      renderList();
      modal.hidden = false;
      document.documentElement.classList.add('gbb-modal-open');
      modal.__gbbPrevLock = [document.documentElement.style.overflow, document.body.style.overflow];
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }
    function closeModal() {
      modal.hidden = true;
      modalSlot = null;
      document.documentElement.classList.remove('gbb-modal-open');
      var prev = modal.__gbbPrevLock || ['', ''];
      document.documentElement.style.overflow = prev[0];
      document.body.style.overflow = prev[1];
      closePops();
    }

    function demoMedia(p) {
      var m = (window.GBB_MEDIA || {})[p.h];
      if (m) return { kind: 'video', url: m, poster: p.vp || '' };
      if (p.vd) return { kind: 'video', url: p.vd, poster: p.vp || '' };
      return null;   // map/gallery-video only — PDP description GIFs proved cross-shuffled between
                     // products, so no fallback: no preview beats showing the WRONG blaster
    }

    function toggleExpand(card) {
      var pid = Number(card.getAttribute('data-pid'));
      var p = byId[pid];
      if (!p || !demoMedia(p)) return;
      var openX = card.querySelector('.gbb-item-x');
      // collapse everything first (also stops any playing demo video)
      [].slice.call(modal.querySelectorAll('.gbb-item-x')).forEach(function (n) { n.remove(); });
      [].slice.call(modal.querySelectorAll('.gbb-item.open')).forEach(function (n) { n.classList.remove('open'); });
      if (openX) return;                                   // it was open → now collapsed
      var dm = demoMedia(p);
      var x = document.createElement('div');
      x.className = 'gbb-item-x';
      if (dm.kind === 'video') {
        x.innerHTML = '<video src="' + dm.url + '" ' + (dm.poster ? 'poster="' + dm.poster + '" ' : '') +
          'muted autoplay loop playsinline preload="metadata"></video>';
        var vid = x.querySelector('video'); if (vid) vid.muted = true;
      } else {
        x.innerHTML = '<img src="' + dm.url + '" alt="" loading="lazy">';
      }
      card.appendChild(x);
      card.classList.add('open');
    }

    function openModalColorPop(anchor) {
      var pid = Number(anchor.getAttribute('data-gbb-mcolor'));
      var p = byId[pid];
      if (!p) return;
      var curVid = Number(anchor.getAttribute('data-vid'));
      var disc = discPct();
      popFor(anchor, p, curVid, function (vid) {
        var v = findVariant(p, vid);
        var item = anchor.closest('.gbb-item');
        anchor.setAttribute('data-vid', vid);
        anchor.innerHTML = colorChip(v, true);
        var img = item.querySelector('.gbb-item-img'); if (img) img.src = v.img;
        var pr = item.querySelector('.gbb-item-price'); if (pr) pr.textContent = fmt(unitPrice(v.p, disc));
        var cm = item.querySelector('.gbb-item-cmp'); if (cm) cm.textContent = fmt(v.cp);
        var ch = item.querySelector('[data-gbb-pick]'); if (ch) ch.setAttribute('data-vid', vid);
      });
    }

    /* ---------- events ---------- */
    function onWidgetClick(e) {
      var colorBtn = e.target.closest('[data-gbb-color]');
      if (colorBtn) { openColorPop(Number(colorBtn.getAttribute('data-gbb-color')), colorBtn); return; }

      var mcolor = e.target.closest('[data-gbb-mcolor]');
      if (mcolor) { openModalColorPop(mcolor); return; }

      var pick = e.target.closest('[data-gbb-pick]');
      if (pick) {
        var pid = Number(pick.getAttribute('data-gbb-pick'));
        var vid = Number(pick.getAttribute('data-vid'));
        if (modalSlot != null && modalSlot > 0) state.slots[state.tier][modalSlot - 1] = { pid: pid, vid: vid };
        closeModal(); renderPrices(); renderSlots();
        return;
      }

      var sortc = e.target.closest('[data-gbb-sortcycle]');
      if (sortc) {
        state.sort = state.sort === '' ? 'asc' : state.sort === 'asc' ? 'desc' : '';
        renderFilters(); renderList();
        return;
      }

      var fchip = e.target.closest('[data-gbb-filter]');
      if (fchip) {
        var fv = fchip.getAttribute('data-gbb-filter');
        state.filter = (fv === state.filter) ? 'all' : fv;   // re-tap an active chip = back to All
        renderFilters(); renderList();
        return;
      }

      var open = e.target.closest('[data-gbb-open]');
      if (open) { openModal(Number(open.getAttribute('data-gbb-open'))); return; }

      if (e.target.closest('[data-gbb-close]')) { closeModal(); return; }

      var step = e.target.closest('[data-gbb-step]');
      if (step) {
        var d = Number(step.getAttribute('data-gbb-step'));
        state.qty = Math.min(cfg.maxQty || 10, Math.max(3, state.qty + d));
        renderTier();
        return;
      }

      var card = e.target.closest('.gbb-item');
      if (card && modal.contains(card) && !e.target.closest('button') && !e.target.closest('.gbb-pop-list')) {
        toggleExpand(card);
        return;
      }

      var bar = e.target.closest('[data-gbb-bar]');
      if (bar && !e.target.closest('[data-gbb-expand]')) {
        state.tier = Number(bar.getAttribute('data-gbb-bar'));
        renderTier();
        return;
      }
    }
    root.addEventListener('click', onWidgetClick);
    modal.addEventListener('click', onWidgetClick);   // modal is portaled to <body>, clicks no longer bubble through root

    if (!window.__gbbPopCloser) {
      window.__gbbPopCloser = true;
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.gbb-pop') && !e.target.closest('.gbb-pop-list')) {
          closePops();
        }
      });
    }

    // follow native picker changes (sticky ATC picker, bfcache, etc.)
    document.addEventListener('change', function (e) {
      var np = nativePicker();
      if (np && np.contains(e.target)) {
        setTimeout(function () { readHostVid(); renderPrices(); renderSlots(); }, 60);
      }
    });

    /* ---------- sticky ATC gating: show only after the buy box scrolls away ---------- */
    (function () {
      var target = document.querySelector('.product-form__buttons') || root;
      if (!('IntersectionObserver' in window)) { document.documentElement.classList.add('gbb-sticky-show'); return; }
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        var below = entries[0].boundingClientRect.top < 0;   // buy box is ABOVE the viewport → user scrolled past it
        document.documentElement.classList.toggle('gbb-sticky-show', !visible && below);
      }, { threshold: 0 });
      io.observe(target);
    })();

    /* ---------- one-write add-to-cart ---------- */
    function collectItems() {
      var items = [];
      function push(vid) {
        for (var i = 0; i < items.length; i++) if (items[i].id === vid) { items[i].quantity++; return; }
        items.push({ id: vid, quantity: 1 });
      }
      push(readHostVid());
      (state.slots[state.tier] || []).forEach(function (slot) {
        var r = slotResolved(slot); push(r.v.id);
      });
      return items;
    }

    function bosTagHostForm(f) {
      /* R3a: the host unit is added by the native form replay (and Buy now): carry the arm the widget showed. */
      if (!bosValue || !f) return;
      try {
        var input = f.querySelector('input[name="properties[_bos_exp]"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[_bos_exp]';
          input.setAttribute('data-gbb-bos', '1');
          f.appendChild(input);
        }
        if (!input.value) input.value = bosValue;
      } catch (err) {}
    }
    bosTagHostForm(mainForm());

    /* What each added unit is, for the gift-wrap tier (the same fields the cart state carries). */
    function addonLines(items) {
      return items.map(function (it) {
        var p = host;
        for (var i = 0; i < cfg.products.length; i++) {
          if (cfg.products[i].vs.some(function (v) { return v.id === it.id; })) { p = cfg.products[i]; break; }
        }
        return { handle: p.h, productType: p.ty, quantity: it.quantity };
      });
    }

    /* Hidden fields for the native submit. Item numbers start at 20 so they never meet the theme's own
       items[0..] offer fields (Shopify accepts the gap); the Blaster Club fields follow after them. */
    function injectFields(f, items, attributes) {
      var made = [], next = 20;
      [].slice.call(f.elements || []).forEach(function (el) {
        var m = /^items\[(\d+)\]/.exec(el.name || '');
        if (m) next = Math.max(next, Number(m[1]) + 1);
      });
      function field(name, value) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = String(value);
        input.setAttribute('data-gbb-one-write', '1');
        f.appendChild(input);
        made.push(input);
      }
      items.forEach(function (it) {
        var n = next++;
        field('items[' + n + '][id]', it.id);
        field('items[' + n + '][quantity]', it.quantity);
        Object.keys(it.properties || {}).forEach(function (k) { field('items[' + n + '][properties][' + k + ']', it.properties[k]); });
      });
      Object.keys(attributes || {}).forEach(function (k) { field('attributes[' + k + ']', attributes[k]); });
      return made;
    }

    function replay(f, submitter) {
      f.__gbbPass = true;
      var btn = submitter && submitter.isConnected && submitter.form === f ? submitter : f.querySelector('button[name="add"], [type="submit"]');
      try { if (f.requestSubmit) f.requestSubmit(btn || undefined); else f.submit(); }
      catch (err) { try { f.requestSubmit(); } catch (e2) { f.submit(); } }
      f.__gbbPass = false;
    }

    /* ONE cart write: the native submit adds the host unit and carries the extra units and the gift-wrap
       line as hidden fields. The theme builds its FormData from the form synchronously while the submit
       event is dispatched, so the fields are removed again right after. One request is all-or-nothing:
       no partial bundle, and the theme shows its own error if the add fails. The gift wrap only rides
       along when worked out on the server's cart (one /cart.js read right before the add): another tab
       may have changed the cart or opted out. Otherwise reconcile adds the wrap after the add, as before. */
    function handleSubmit(f, e) {
      bosTagHostForm(f);
      if (f.__gbbBusy) {                          // this bundle is still being sent → swallow the double-tap
        if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
        return true;
      }
      var items = collectItems();
      var q = f.querySelector('input[name="quantity"]'); if (q) q.value = '1';
      var hostVid = readHostVid();
      var extras = [];
      items.forEach(function (it) {
        var qn = it.id === hostVid ? it.quantity - 1 : it.quantity;
        if (qn > 0) extras.push(bosValue ? { id: it.id, quantity: qn, properties: { _bos_exp: bosValue } } : { id: it.id, quantity: qn });
      });
      var api = window.GBDynamicAddons, bus = window.GBCart, lines = addonLines(items), foldable = false;
      try {
        foldable = !!(api && typeof api.canAddFields === 'function' && typeof api.addFields === 'function' &&
          bus && typeof bus.readCart === 'function' && api.canAddFields(lines));
      } catch (err) { foldable = false; }
      if (!extras.length && !foldable) return false;   // Buy 1 with nothing to carry → pure native path
      f.__gbbBusy = true;
      var submitter = e && e.submitter;
      function send(addons, replayIt) {
        var fields = injectFields(f, extras.concat((addons && addons.items) || []), addons && addons.attributes);
        if (replayIt) replay(f, submitter);
        setTimeout(function () {
          fields.forEach(function (input) { if (input.parentNode) input.parentNode.removeChild(input); });
          f.__gbbBusy = false;
        }, 0);
      }
      if (!foldable) { send(null, !e); return true; }  // the native submit (or the gate replay) carries the extras
      if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
      var sent = false;
      function once(fresh) {
        if (sent) return;
        sent = true;
        var addons = null;
        try { addons = fresh ? api.addFields(lines, fresh) : null; } catch (err) { addons = null; }
        send(addons, true);
      }
      // Read after the cart lane is idle (the Blaster Club add waits for it too). A cart job queued during
      // the read would make that add wait again, so then the wrap is not carried.
      var lane = function () { return typeof bus.whenIdle === 'function' ? bus.whenIdle() : null; };
      Promise.resolve(lane()).catch(function () {}).then(function () {
        var tail = lane();
        return bus.readCart(true).then(function (fresh) { return lane() === tail ? fresh : null; });
      }).then(once, function () { once(null); });
      setTimeout(function () { once(null); }, 1000);     // a slow lane or read never holds the add: send without the wrap
      return true;
    }

    /* ---------- init ---------- */
    (function () {
      var warm = findVariant(host, readHostVid());
      if (warm && warm.img) { var im = new Image(); im.src = warm.img; }
    })();
    if (bosPatched) bosApplyTierMarkup();
    renderTier();
    instances.push({ root: root, container: container, handleSubmit: handleSubmit, mainForm: mainForm });
  }

  /* ============ globals: init-all, quick-view re-injection, submit routing ============ */
  function initAll() {
    [].slice.call(document.querySelectorAll('[data-gbb]')).forEach(initWidget);
  }

  document.addEventListener('gb:quickview:ready', initAll);

  function instanceFor(f) {
    for (var i = instances.length - 1; i >= 0; i--) {
      var inst = instances[i];
      if (isSuppressedOutlawLoadoutRoot(inst.root)) continue;
      if (inst.root.isConnected && inst.container.contains(f)) return inst;
    }
    return null;
  }

  // ONE capture-phase interceptor for every instance (PDP + quick-views)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || f.getAttribute('data-type') !== 'add-to-cart-form') return;
    if (f.__gbbPass) return;                      // replay pass-through
    var inst = instanceFor(f);
    if (!inst) return;                            // no widget owns this form → native
    if (inst.mainForm() !== f) return;
    inst.handleSubmit(f, e);
  }, true);

  ready(function () {
    initAll();
    window.__gbbReady = true;
    // replay a submit the parse-time gate held while we were still loading
    var pend = window.__gbbPending;
    window.__gbbPending = null;
    if (pend && pend.form) {
      var inst = instanceFor(pend.form);
      var handled = false;
      if (inst && inst.mainForm() === pend.form) {
        handled = inst.handleSubmit(pend.form, null) === true;
      }
      if (!handled) {
        pend.form.__gbbPass = true;
        var pbtn = pend.form.querySelector('button[name="add"], [type="submit"]');
        if (pend.form.requestSubmit) pend.form.requestSubmit(pbtn || undefined); else pend.form.submit();
        setTimeout(function () { pend.form.__gbbPass = false; }, 500);
      }
    }
    // quick-add modals inject fresh widget copies after page load — bind them as they appear
    try {
      var moT = null;
      new MutationObserver(function () {
        if (moT) return;
        moT = setTimeout(function () { moT = null; initAll(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    } catch (err) {}
  });
})();
